import { ThemeVars } from 'core/utilities/theme';

export const pageFullHeaderHeight = (showAppHeaderEnv: boolean) => {
  let headerHeight = 0;

  // Env header
  if (showAppHeaderEnv) headerHeight += ThemeVars.headerEnvHeight;

  // App header
  headerHeight += ThemeVars.headerMenuHeight;

  // Page header
  headerHeight += ThemeVars.pageHeaderHeight;

  return headerHeight;
};

export const scrollToSection = (id: string, showAppHeaderEnv: boolean) => {
  const section = document.getElementById(id);

  if (section) {
    document.documentElement.scrollTop = section.offsetTop - pageFullHeaderHeight(showAppHeaderEnv);
  }
};

export const scrollToPosition = (top: number, left: number) => {
  document.documentElement.scrollTop = top;
  document.documentElement.scrollLeft = left;
};

export const scrollToElement = (element: HTMLElement, extraOffset = 0) => {
  let yPosition = 0;

  let parentElement: HTMLElement | undefined = element;

  // Iterate through parent until we reach the top
  while (parentElement) {
    yPosition += (parentElement.offsetTop - parentElement.scrollTop + parentElement.clientTop);
    parentElement = parentElement.offsetParent as HTMLElement | undefined;
  }

  document.documentElement.scrollTop = yPosition - extraOffset;
};
